import produce from "immer";

import { LoadState } from "../../../constants/enums";
import { IGLAgingReportState, initialGLAgingReportState } from "./GLAgingReport.types";
import { GLAgingReportActions } from ".";
import {
  CLEAR_GL_AGING_REPORT,
  FETCH_GL_AGING_REPORT_LIST_FAILED,
  FETCH_GL_AGING_REPORT_LIST_PROGRESS,
  FETCH_GL_AGING_REPORT_LIST_SUCCESS,
} from "./GLAgingReportActions";

export const glAgingReportReducer = (
  state: IGLAgingReportState = initialGLAgingReportState,
  action: GLAgingReportActions
) => {
  switch (action.type) {
    case FETCH_GL_AGING_REPORT_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.InProgress;
        draftState.list = [];
        draftState.totalRecords = 0;
      });
      return newState;
    }
    case FETCH_GL_AGING_REPORT_LIST_SUCCESS: {
      const { data, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Loaded;
        draftState.list = data;
        draftState.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_GL_AGING_REPORT_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Failed;
        draftState.list = [];
        draftState.totalRecords = 0;
      });
      return newState;
    }

    case CLEAR_GL_AGING_REPORT: {
      return initialGLAgingReportState;
    }

    default: {
      return state;
    }
  }
};
